module.exports = __webpack_public_path__ + "img/icon_hotel.840ad9a1.svg";